<div class="tableHeader">
    <div class="row-items table-content odd">
        <div class="col-item w1 odd">
            Id
        </div>

        <div class="col-item w3">
            Card number
        </div>

        <div class="col-item w4">
            Card name
        </div>
    </div>
</div>
